<div class="option">
  <div class="option__item">
    {{  optType === OptionTypeEnum.CALL ? context.data.optionSymbolCall : context.data.optionSymbolPut}}
  </div>
  <div class="option__types">
    <div class="option__type" (click)="changeOptTypeAndLoadData(OptionTypeEnum.CALL)" [ngClass]="{'option__type--active':optType === OptionTypeEnum.CALL}">
      Call
    </div>
    <div class="option__type" (click)="changeOptTypeAndLoadData(OptionTypeEnum.PUT)" [ngClass]="{'option__type--active':optType === OptionTypeEnum.PUT}">
      Put
    </div>
  </div>
</div>



<form class="filters-form" [formGroup]="form">
  <div tuiGroup [collapsed]="true">
    <tui-radio-block
    [class.radio-selected]="form.get('mode').value === singleContractAnalyzerTypeEnum.BID"
    contentAlign="right"
    formControlName="mode"
    [item]="singleContractAnalyzerTypeEnum.BID"
    size="s"
    >
      Bid
    </tui-radio-block>
    <tui-radio-block
    [class.radio-selected]="form.get('mode').value === singleContractAnalyzerTypeEnum.ASK"
    contentAlign="right"
    formControlName="mode"
    [item]="singleContractAnalyzerTypeEnum.ASK"
    size="s"
    >
      Ask
    </tui-radio-block>
    <tui-radio-block
      [class.radio-selected]="form.get('mode').value === singleContractAnalyzerTypeEnum.LAST_PRICE"
      contentAlign="right"
      formControlName="mode"
      [item]="singleContractAnalyzerTypeEnum.LAST_PRICE"
      size="s"
    >
      Last price
    </tui-radio-block>
    <tui-radio-block
      [class.radio-selected]="form.get('mode').value === singleContractAnalyzerTypeEnum.IV"
      contentAlign="right"
      formControlName="mode"
      [item]="singleContractAnalyzerTypeEnum.IV"
      size="s"
    >
      IV
    </tui-radio-block>
    <tui-radio-block
      [class.radio-selected]="form.get('mode').value === 'TABLE'"
      contentAlign="right"
      formControlName="mode"
      [item]="'TABLE'"
      size="s"
    >
      Table
    </tui-radio-block>
  </div>
</form>

<ng-container *ngIf="form.get('mode').value !== 'TABLE'">
  <iv-live-contract-viewer
    [isLoading]="$isLoading | async"
    [optionData]="optionData"
    [params]="params"
  ></iv-live-contract-viewer>
</ng-container>

<ng-container *ngIf="form.get('mode').value === 'TABLE'">
  <tui-loader [overlay]="true" [showLoader]="$isLoading | async">
    <div *ngIf="$isLoading | async" class="void-box"></div>
    <iv-live-simple-table
      *ngIf="!($isLoading | async)"
      [columns]="tableColumns"
      [titlesColumns]="tableTitlesColumns"
      [data]="$any(optionData)"
    ></iv-live-simple-table>
  </tui-loader>
</ng-container>
